import { Message, proto3 } from '@bufbuild/protobuf';
import { DataMsgBodyType } from './plugnmeet_datamessage_pb.ts';
/**
 * @generated from enum plugnmeet.SwitchPresenterTask
 */
export var SwitchPresenterTask;
(function (SwitchPresenterTask) {
    /**
     * @generated from enum value: PROMOTE = 0;
     */
    SwitchPresenterTask[SwitchPresenterTask["PROMOTE"] = 0] = "PROMOTE";
    /**
     * @generated from enum value: DEMOTE = 1;
     */
    SwitchPresenterTask[SwitchPresenterTask["DEMOTE"] = 1] = "DEMOTE";
})(SwitchPresenterTask || (SwitchPresenterTask = {}));
// Retrieve enum metadata with: proto3.getEnumType(SwitchPresenterTask)
proto3.util.setEnumType(SwitchPresenterTask, 'plugnmeet.SwitchPresenterTask', [
    { no: 0, name: 'PROMOTE' },
    { no: 1, name: 'DEMOTE' },
]);
/**
 * @generated from enum plugnmeet.ExternalMediaPlayerTask
 */
export var ExternalMediaPlayerTask;
(function (ExternalMediaPlayerTask) {
    /**
     * @generated from enum value: START_PLAYBACK = 0;
     */
    ExternalMediaPlayerTask[ExternalMediaPlayerTask["START_PLAYBACK"] = 0] = "START_PLAYBACK";
    /**
     * @generated from enum value: END_PLAYBACK = 1;
     */
    ExternalMediaPlayerTask[ExternalMediaPlayerTask["END_PLAYBACK"] = 1] = "END_PLAYBACK";
})(ExternalMediaPlayerTask || (ExternalMediaPlayerTask = {}));
// Retrieve enum metadata with: proto3.getEnumType(ExternalMediaPlayerTask)
proto3.util.setEnumType(ExternalMediaPlayerTask, 'plugnmeet.ExternalMediaPlayerTask', [
    { no: 0, name: 'START_PLAYBACK' },
    { no: 1, name: 'END_PLAYBACK' },
]);
/**
 * @generated from enum plugnmeet.ExternalDisplayLinkTask
 */
export var ExternalDisplayLinkTask;
(function (ExternalDisplayLinkTask) {
    /**
     * @generated from enum value: START_EXTERNAL_LINK = 0;
     */
    ExternalDisplayLinkTask[ExternalDisplayLinkTask["START_EXTERNAL_LINK"] = 0] = "START_EXTERNAL_LINK";
    /**
     * @generated from enum value: STOP_EXTERNAL_LINK = 1;
     */
    ExternalDisplayLinkTask[ExternalDisplayLinkTask["STOP_EXTERNAL_LINK"] = 1] = "STOP_EXTERNAL_LINK";
})(ExternalDisplayLinkTask || (ExternalDisplayLinkTask = {}));
// Retrieve enum metadata with: proto3.getEnumType(ExternalDisplayLinkTask)
proto3.util.setEnumType(ExternalDisplayLinkTask, 'plugnmeet.ExternalDisplayLinkTask', [
    { no: 0, name: 'START_EXTERNAL_LINK' },
    { no: 1, name: 'STOP_EXTERNAL_LINK' },
]);
/**
 * @generated from message plugnmeet.CommonResponse
 */
export class CommonResponse extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool status = 1;
         */
        this.status = false;
        /**
         * @generated from field: string msg = 2;
         */
        this.msg = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CommonResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CommonResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CommonResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CommonResponse, a, b);
    }
}
CommonResponse.runtime = proto3;
CommonResponse.typeName = 'plugnmeet.CommonResponse';
CommonResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'status', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: 'msg', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message plugnmeet.VerifyTokenReq
 */
export class VerifyTokenReq extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new VerifyTokenReq().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VerifyTokenReq().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VerifyTokenReq().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VerifyTokenReq, a, b);
    }
}
VerifyTokenReq.runtime = proto3;
VerifyTokenReq.typeName = 'plugnmeet.VerifyTokenReq';
VerifyTokenReq.fields = proto3.util.newFieldList(() => [
    {
        no: 1,
        name: 'is_production',
        kind: 'scalar',
        T: 8 /* ScalarType.BOOL */,
        opt: true,
    },
]);
/**
 * @generated from message plugnmeet.VerifyTokenRes
 */
export class VerifyTokenRes extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool status = 1;
         */
        this.status = false;
        /**
         * @generated from field: string msg = 2;
         */
        this.msg = '';
        /**
         * @generated from field: bool enabled_e2ee = 6;
         */
        this.enabledE2ee = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new VerifyTokenRes().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VerifyTokenRes().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VerifyTokenRes().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VerifyTokenRes, a, b);
    }
}
VerifyTokenRes.runtime = proto3;
VerifyTokenRes.typeName = 'plugnmeet.VerifyTokenRes';
VerifyTokenRes.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'status', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: 'msg', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 3,
        name: 'livekit_host',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
    {
        no: 4,
        name: 'token',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
    {
        no: 5,
        name: 'server_version',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
    { no: 6, name: 'enabled_e2ee', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message plugnmeet.MuteUnMuteTrackReq
 */
export class MuteUnMuteTrackReq extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string sid = 1;
         */
        this.sid = '';
        /**
         * @generated from field: string room_id = 2;
         */
        this.roomId = '';
        /**
         * @generated from field: string user_id = 3;
         */
        this.userId = '';
        /**
         * @generated from field: string track_sid = 4;
         */
        this.trackSid = '';
        /**
         * @generated from field: bool muted = 5;
         */
        this.muted = false;
        /**
         * @generated from field: string Requested_user_id = 6;
         */
        this.RequestedUserId = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new MuteUnMuteTrackReq().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MuteUnMuteTrackReq().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MuteUnMuteTrackReq().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MuteUnMuteTrackReq, a, b);
    }
}
MuteUnMuteTrackReq.runtime = proto3;
MuteUnMuteTrackReq.typeName = 'plugnmeet.MuteUnMuteTrackReq';
MuteUnMuteTrackReq.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'sid', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'user_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'track_sid', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'muted', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
    {
        no: 6,
        name: 'Requested_user_id',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
    },
]);
/**
 * @generated from message plugnmeet.RemoveParticipantReq
 */
export class RemoveParticipantReq extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string sid = 1;
         */
        this.sid = '';
        /**
         * @generated from field: string room_id = 2;
         */
        this.roomId = '';
        /**
         * @generated from field: string user_id = 3;
         */
        this.userId = '';
        /**
         * @generated from field: string msg = 4;
         */
        this.msg = '';
        /**
         * @generated from field: bool block_user = 5;
         */
        this.blockUser = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new RemoveParticipantReq().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveParticipantReq().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveParticipantReq().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveParticipantReq, a, b);
    }
}
RemoveParticipantReq.runtime = proto3;
RemoveParticipantReq.typeName = 'plugnmeet.RemoveParticipantReq';
RemoveParticipantReq.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'sid', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'user_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'msg', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'block_user', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message plugnmeet.DataMessageReq
 */
export class DataMessageReq extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string room_id = 1;
         */
        this.roomId = '';
        /**
         * @generated from field: string room_sid = 2;
         */
        this.roomSid = '';
        /**
         * @generated from field: string user_id = 3;
         */
        this.userId = '';
        /**
         * @generated from field: string user_sid = 4;
         */
        this.userSid = '';
        /**
         * @generated from field: plugnmeet.DataMsgBodyType msg_body_type = 5;
         */
        this.msgBodyType = DataMsgBodyType.RAISE_HAND;
        /**
         * @generated from field: string msg = 6;
         */
        this.msg = '';
        /**
         * @generated from field: string Requested_user_id = 7;
         */
        this.RequestedUserId = '';
        /**
         * @generated from field: repeated string send_to = 8;
         */
        this.sendTo = [];
        /**
         * @generated from field: bool is_admin = 9;
         */
        this.isAdmin = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new DataMessageReq().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DataMessageReq().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DataMessageReq().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DataMessageReq, a, b);
    }
}
DataMessageReq.runtime = proto3;
DataMessageReq.typeName = 'plugnmeet.DataMessageReq';
DataMessageReq.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'room_sid', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'user_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'user_sid', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 5,
        name: 'msg_body_type',
        kind: 'enum',
        T: proto3.getEnumType(DataMsgBodyType),
    },
    { no: 6, name: 'msg', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 7,
        name: 'Requested_user_id',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
    },
    {
        no: 8,
        name: 'send_to',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        repeated: true,
    },
    { no: 9, name: 'is_admin', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message plugnmeet.RoomEndAPIReq
 */
export class RoomEndAPIReq extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string room_id = 1;
         */
        this.roomId = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new RoomEndAPIReq().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RoomEndAPIReq().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RoomEndAPIReq().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RoomEndAPIReq, a, b);
    }
}
RoomEndAPIReq.runtime = proto3;
RoomEndAPIReq.typeName = 'plugnmeet.RoomEndAPIReq';
RoomEndAPIReq.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message plugnmeet.ChangeVisibilityRes
 */
export class ChangeVisibilityRes extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string room_id = 1;
         */
        this.roomId = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ChangeVisibilityRes().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChangeVisibilityRes().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChangeVisibilityRes().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChangeVisibilityRes, a, b);
    }
}
ChangeVisibilityRes.runtime = proto3;
ChangeVisibilityRes.typeName = 'plugnmeet.ChangeVisibilityRes';
ChangeVisibilityRes.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 2,
        name: 'visible_notepad',
        kind: 'scalar',
        T: 8 /* ScalarType.BOOL */,
        opt: true,
    },
    {
        no: 3,
        name: 'visible_white_board',
        kind: 'scalar',
        T: 8 /* ScalarType.BOOL */,
        opt: true,
    },
]);
/**
 * @generated from message plugnmeet.SwitchPresenterReq
 */
export class SwitchPresenterReq extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: plugnmeet.SwitchPresenterTask task = 1;
         */
        this.task = SwitchPresenterTask.PROMOTE;
        /**
         * @generated from field: string user_id = 2;
         */
        this.userId = '';
        /**
         * @generated from field: string room_id = 3;
         */
        this.roomId = '';
        /**
         * @generated from field: string Requested_user_id = 4;
         */
        this.RequestedUserId = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SwitchPresenterReq().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SwitchPresenterReq().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SwitchPresenterReq().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SwitchPresenterReq, a, b);
    }
}
SwitchPresenterReq.runtime = proto3;
SwitchPresenterReq.typeName = 'plugnmeet.SwitchPresenterReq';
SwitchPresenterReq.fields = proto3.util.newFieldList(() => [
    {
        no: 1,
        name: 'task',
        kind: 'enum',
        T: proto3.getEnumType(SwitchPresenterTask),
    },
    { no: 2, name: 'user_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 4,
        name: 'Requested_user_id',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
    },
]);
/**
 * @generated from message plugnmeet.ExternalMediaPlayerReq
 */
export class ExternalMediaPlayerReq extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: plugnmeet.ExternalMediaPlayerTask task = 1;
         */
        this.task = ExternalMediaPlayerTask.START_PLAYBACK;
        /**
         * @generated from field: string room_id = 4;
         */
        this.roomId = '';
        /**
         * @generated from field: string user_id = 5;
         */
        this.userId = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ExternalMediaPlayerReq().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExternalMediaPlayerReq().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExternalMediaPlayerReq().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExternalMediaPlayerReq, a, b);
    }
}
ExternalMediaPlayerReq.runtime = proto3;
ExternalMediaPlayerReq.typeName = 'plugnmeet.ExternalMediaPlayerReq';
ExternalMediaPlayerReq.fields = proto3.util.newFieldList(() => [
    {
        no: 1,
        name: 'task',
        kind: 'enum',
        T: proto3.getEnumType(ExternalMediaPlayerTask),
    },
    {
        no: 2,
        name: 'url',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
    {
        no: 3,
        name: 'seek_to',
        kind: 'scalar',
        T: 1 /* ScalarType.DOUBLE */,
        opt: true,
    },
    { no: 4, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'user_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message plugnmeet.ExternalDisplayLinkReq
 */
export class ExternalDisplayLinkReq extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: plugnmeet.ExternalDisplayLinkTask task = 1;
         */
        this.task = ExternalDisplayLinkTask.START_EXTERNAL_LINK;
        /**
         * @generated from field: string room_id = 4;
         */
        this.roomId = '';
        /**
         * @generated from field: string user_id = 5;
         */
        this.userId = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ExternalDisplayLinkReq().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExternalDisplayLinkReq().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExternalDisplayLinkReq().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExternalDisplayLinkReq, a, b);
    }
}
ExternalDisplayLinkReq.runtime = proto3;
ExternalDisplayLinkReq.typeName = 'plugnmeet.ExternalDisplayLinkReq';
ExternalDisplayLinkReq.fields = proto3.util.newFieldList(() => [
    {
        no: 1,
        name: 'task',
        kind: 'enum',
        T: proto3.getEnumType(ExternalDisplayLinkTask),
    },
    {
        no: 2,
        name: 'url',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
    { no: 4, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'user_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message plugnmeet.CreateEtherpadSessionRes
 */
export class CreateEtherpadSessionRes extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool status = 1;
         */
        this.status = false;
        /**
         * @generated from field: string msg = 2;
         */
        this.msg = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CreateEtherpadSessionRes().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateEtherpadSessionRes().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateEtherpadSessionRes().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateEtherpadSessionRes, a, b);
    }
}
CreateEtherpadSessionRes.runtime = proto3;
CreateEtherpadSessionRes.typeName = 'plugnmeet.CreateEtherpadSessionRes';
CreateEtherpadSessionRes.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'status', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: 'msg', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 3,
        name: 'pad_id',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
    {
        no: 4,
        name: 'readonly_pad_id',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
]);
/**
 * @generated from message plugnmeet.CleanEtherpadReq
 */
export class CleanEtherpadReq extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string room_id = 1;
         */
        this.roomId = '';
        /**
         * @generated from field: string node_id = 2;
         */
        this.nodeId = '';
        /**
         * @generated from field: string pad_id = 3;
         */
        this.padId = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CleanEtherpadReq().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CleanEtherpadReq().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CleanEtherpadReq().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CleanEtherpadReq, a, b);
    }
}
CleanEtherpadReq.runtime = proto3;
CleanEtherpadReq.typeName = 'plugnmeet.CleanEtherpadReq';
CleanEtherpadReq.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'node_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'pad_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message plugnmeet.ChangeEtherpadStatusReq
 */
export class ChangeEtherpadStatusReq extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string room_id = 1;
         */
        this.roomId = '';
        /**
         * @generated from field: bool is_active = 2;
         */
        this.isActive = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ChangeEtherpadStatusReq().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChangeEtherpadStatusReq().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChangeEtherpadStatusReq().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChangeEtherpadStatusReq, a, b);
    }
}
ChangeEtherpadStatusReq.runtime = proto3;
ChangeEtherpadStatusReq.typeName = 'plugnmeet.ChangeEtherpadStatusReq';
ChangeEtherpadStatusReq.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'is_active', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message plugnmeet.ApproveWaitingUsersReq
 */
export class ApproveWaitingUsersReq extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string room_id = 1;
         */
        this.roomId = '';
        /**
         * @generated from field: string user_id = 2;
         */
        this.userId = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ApproveWaitingUsersReq().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApproveWaitingUsersReq().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApproveWaitingUsersReq().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApproveWaitingUsersReq, a, b);
    }
}
ApproveWaitingUsersReq.runtime = proto3;
ApproveWaitingUsersReq.typeName = 'plugnmeet.ApproveWaitingUsersReq';
ApproveWaitingUsersReq.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'user_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message plugnmeet.UpdateWaitingRoomMessageReq
 */
export class UpdateWaitingRoomMessageReq extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string room_id = 1;
         */
        this.roomId = '';
        /**
         * @generated from field: string msg = 2;
         */
        this.msg = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new UpdateWaitingRoomMessageReq().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateWaitingRoomMessageReq().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateWaitingRoomMessageReq().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateWaitingRoomMessageReq, a, b);
    }
}
UpdateWaitingRoomMessageReq.runtime = proto3;
UpdateWaitingRoomMessageReq.typeName = 'plugnmeet.UpdateWaitingRoomMessageReq';
UpdateWaitingRoomMessageReq.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'msg', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message plugnmeet.UpdateUserLockSettingsReq
 */
export class UpdateUserLockSettingsReq extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string room_sid = 1;
         */
        this.roomSid = '';
        /**
         * @generated from field: string room_id = 2;
         */
        this.roomId = '';
        /**
         * @generated from field: string user_id = 3;
         */
        this.userId = '';
        /**
         * @generated from field: string service = 4;
         */
        this.service = '';
        /**
         * @generated from field: string direction = 5;
         */
        this.direction = '';
        /**
         * @generated from field: string Requested_user_id = 6;
         */
        this.RequestedUserId = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new UpdateUserLockSettingsReq().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateUserLockSettingsReq().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateUserLockSettingsReq().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateUserLockSettingsReq, a, b);
    }
}
UpdateUserLockSettingsReq.runtime = proto3;
UpdateUserLockSettingsReq.typeName = 'plugnmeet.UpdateUserLockSettingsReq';
UpdateUserLockSettingsReq.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'room_sid', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'user_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'service', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'direction', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 6,
        name: 'Requested_user_id',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
    },
]);
